import {
  Injector,
  OnDestroy,
  NgModule,
  Component,
  EventEmitter,
  ElementRef,
  ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';

import { OSharedModule } from '../../shared';
import { AppConfig } from '../../config/app-config';
import {
  DialogService,
  OTranslateService,
  OModulesInfoService
} from '../../services';

import { OUserInfoModule } from '../../components';


export const DEFAULT_INPUTS_O_APP_HEADER = [
];

export const DEFAULT_OUTPUTS_O_APP_HEADER = [
  'toggleSidenav'
];


export class OAppHeaderComponent implements OnDestroy {

  public static DEFAULT_INPUTS_O_APP_HEADER = DEFAULT_INPUTS_O_APP_HEADER;
  public static DEFAULT_OUTPUTS_O_APP_HEADER = DEFAULT_OUTPUTS_O_APP_HEADER;

  protected dialogService: DialogService;
  protected translateService: OTranslateService;
  protected modulesInfoService: OModulesInfoService;
  protected _config: AppConfig;
  protected availableLangs: string[];
  protected _headerTitle = '';

  protected modulesInfoSubscription: Subscription;
  public toggleSidenav = new EventEmitter<void>();

  constructor(
    private router: Router,
    protected injector: Injector,
    protected elRef: ElementRef
  ) {
    this.dialogService = this.injector.get(DialogService);
    this.translateService = this.injector.get(OTranslateService);
    this._config = this.injector.get(AppConfig);
    this.availableLangs = this._config.getConfiguration().applicationLocales;
    this.modulesInfoService = this.injector.get(OModulesInfoService);

    // this.userInfo = this.modulesInfoService.();
    this.modulesInfoSubscription = this.modulesInfoService.getModuleChangeObservable().subscribe(res => {
      this.headerTitle = res.name;
    });
  }

  ngOnDestroy() {
    this.modulesInfoSubscription.unsubscribe();
  }

  onLogoutClick() {
    this.dialogService.confirm('CONFIRM', 'MESSAGES.CONFIRM_LOGOUT').then(
      res => {
        if (res === true) {
          this.router.navigate(['/login', {
            'session-expired': true
          }]);
        }
      }
    );
  }

  configureI18n(lang: any) {
    if (this.translateService && this.translateService.getCurrentLang() !== lang) {
      this.translateService.use(lang);
    }
  }

  getFlagClass(lang: string) {
    const flagName = (lang !== 'en') ? lang : 'gb';
    return 'flag-icon-' + flagName;
  }

  getCurrentLang() : string {
    return this.translateService.getCurrentLang();
  }

  getAvailableLangs() : string[] {
    return this.availableLangs;
  }

  get headerTitle() : string {
    return this._headerTitle;
  }

  set headerTitle(value : string) {
    this._headerTitle = value;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-app-header',
  inputs: DEFAULT_INPUTS_O_APP_HEADER,
  outputs: DEFAULT_OUTPUTS_O_APP_HEADER,
  template: `
    <nav class="application-header">
      <md-icon class="sidenav-toggle" (click)="toggleSidenav.emit()">menu</md-icon>
      <span fxLayout="row" fxLayoutAlign="center center" class="application-header-title">{{ headerTitle | oTranslate }}</span>
      <o-user-info></o-user-info>
      <button class="menu-button" md-icon-button [mdMenuTriggerFor]="langMenu">
        <span class="flag-icon {{ getFlagClass(getCurrentLang()) }}"></span>
      </button>
      <md-menu #langMenu="mdMenu" yPosition="below">
        <button md-menu-item *ngFor="let lang of getAvailableLangs()" (click)="configureI18n(lang)">
          <span class="flag-icon {{ getFlagClass(lang) }}"></span>
          <span>{{ 'LOCALE_' + lang | oTranslate }}</span>
        </button>
      </md-menu>
    </nav>
  `,
  styles: [`
    .o-app-header{z-index:2;box-shadow:0px 2px 6px rgba(0,0,0,0.24)}.o-app-header .application-header{display:flex;flex-wrap:wrap;padding:8px 16px 8px 0}.o-app-header .application-header .sidenav-toggle{text-align:center;position:absolute;top:0px;padding:16px 16px;cursor:pointer}.o-app-header .application-header .application-header-title{cursor:initial;flex:1 1 auto}
  `],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.o-app-header]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Router, },
{type: Injector, },
{type: ElementRef, },
];
}


export class OAppHeaderModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    OSharedModule,
    OUserInfoModule
  ],
  declarations: [
    OAppHeaderComponent
  ],
  exports: [OAppHeaderComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
